import * as ngCore from '@angular/core'

import * as input from '../../../input'
import { Store } from '../../store'

/** Renders controlled pagination for known- and unknown-count sources. */
@ngCore.Component({
  imports: [input.select.single.Component, input.text.Component],
  selector: 'atn-ds-table-pagination',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Shared table state used by the template. */
  public readonly store = ngCore.inject(Store)

  /**
   * Page-size options in the design select's item shape.
   *
   * The table config stores numeric page sizes, while the shared select input
   * expects label/value item objects; this signal performs that presentation
   * conversion without changing the controlled config.
   */
  public readonly pageSizeItemsSg = ngCore.computed(
    (config = this.store.paginationConfigSg()) =>
      (config?.supportedPageSizes ?? []).map(value => ({
        label: value.toString(),
        value,
      })),
  )

  /**
   * Requests a controlled page after validating text-input output.
   *
   * Empty, fractional, and non-numeric values are ignored here. Store performs
   * the second positivity check before invoking the consumer callback.
   */
  public pageChangeHandler(value: string | undefined): void {
    const page = Number(value)
    if (Number.isInteger(page)) {
      this.store.changePage(page)
    }
  }
}
